import type { UserDetail } from '~/modules/settings/api/lib/schemas';

import { UserDetailContext } from './UserDetailContext';

interface UserDetailProviderProps {
  user: UserDetail;
  children: React.ReactNode;
}

export const UserDetailProvider = ({
  user,
  children,
}: UserDetailProviderProps) => {
  return (
    <UserDetailContext.Provider value={user}>
      {children}
    </UserDetailContext.Provider>
  );
};

UserDetailProvider.displayName = 'UserDetailProvider';
